import createIcon from '../../createIcon';

/**
 * @component @name MeetingRoom
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQgNlYyMUgzVjE5SDVWM0gxNFY0SDE5VjE5SDIxVjIxSDE3VjZIMTRaTTEwIDExVjEzSDEyVjExSDEwWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MeetingRoom = createIcon('MeetingRoom', [
  ['path', { d: 'M14 6V21H3V19H5V3H14V4H19V19H21V21H17V6H14ZM10 11V13H12V11H10Z', key: 'kynqeq' }],
]);

export default MeetingRoom;
